import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import fetchClient from "@src/api/lib/fetch-client";
import { ROUTES } from "@src/constants";
import { menuConfig } from "@src/layouts/config";
import { ConfigState } from "@src/types/state";



const initialState: ConfigState = {
  menuListConfig: undefined,
  flash_sale: undefined,
  on_sale: false,
  collections: [],
  categories: [],
  total_cart_items: 0,
  currencyRates: [],
  branches: [],
  payment_methods: [],
  spx_address_version: 0,
  use_spx_address_schema: false,
};

const configSlice = createSlice({
  name: "config",
  initialState,
  reducers: {
    setConfig: (state, action: PayloadAction<ConfigState>) => {
      const configData = action.payload;
      state.menuListConfig = generateMenuConfigList(configData);
      state.flash_sale = configData.flash_sale;
      state.on_sale = configData.on_sale;
      state.collections = configData.collections;
      state.categories = configData.categories;
      state.branches = configData.branches;
      state.payment_methods = configData.payment_methods;
      state.currencyRates = configData.currencyRates;
      state.spx_address_version = configData.spx_address_version ?? 0;
      state.use_spx_address_schema = Boolean(configData.use_spx_address_schema);
      state.promo_bar = configData.promo_bar ?? null;
      if (typeof configData.total_cart_items === "number") {
        state.total_cart_items = configData.total_cart_items;
      }
    },
    setTotalCartItems: (state, action: PayloadAction<number>) => {
      state.total_cart_items = Math.max(0, action.payload || 0);
    },
    fetchConfig: (state) => {
      const { data } = fetchClient({
        url: "/config",
        method: "GET",
      });
      state.menuListConfig = generateMenuConfigList(data);
      state.flash_sale = data.flash_sale;
      state.on_sale = data.on_sale;
      state.collections = data.collections;
      state.categories = data.categories;
    },
    updateFlashSale: (state) => {
      if (state.flash_sale) {
        const now = new Date().getTime();
        const flashSaleActive = (state.flash_sale.to && now < new Date(state.flash_sale.to).getTime()) as boolean;
        state.on_sale = (state.on_sale || flashSaleActive) as boolean;
        state.flash_sale = {
          ...state.flash_sale,
          isActive: flashSaleActive,
          isNotStarted: now < new Date(state.flash_sale.from).getTime(),
          isGoingOn:
            now > new Date(state.flash_sale.from).getTime() &&
            now < new Date(state.flash_sale.to).getTime(),
        };
      }
    }
  },
});

export const generateMenuConfigList = (config: ConfigState) => {
  return menuConfig
    .map((item) => {
      if (item.path === ROUTES.COLLECTION && Array.isArray(config.collections) && config.collections.length > 0) {
        const subMenu = config.collections.map((col) => ({
          title: col.name.toUpperCase(),
          path: `${ROUTES.COLLECTION}/${col.slug}`,
          isActive: true,
        }));
        subMenu.unshift({
          title: "Tất cả",
          key: "all",
          path: ROUTES.COLLECTION,
          isActive: true,
        });
        return {
          ...item,
          subMenu,
          isActive: true,
        };
      }

      if (item.path === ROUTES.PRODUCT && Array.isArray(config.categories) && config.categories.length > 0) {
        const subMenu = config.categories.map((cat) => ({
          title: cat.name.toUpperCase(),
          path: `${ROUTES.PRODUCT_CATEGORY}/${cat.slug}`,
          isActive: true,
        }));
        subMenu.unshift({
          title: "Tất cả",
          key: "all",
          path: ROUTES.PRODUCT,
          isActive: true,
        });
        return {
          ...item,
          subMenu,
          isActive: true,
        };
      }

      return item;
    })
    .filter((item) => item.isActive);
};

export const { setConfig, setTotalCartItems, fetchConfig, updateFlashSale } = configSlice.actions;
export default configSlice.reducer;
